import styled from '@emotion/styled';
import { ModalContainer, UIcon, IconContainer } from './CreateAdminUser';

const ViewDetails = (props: any) => {
  const data = props.data;

  return (
    <ModalContainer>
      <div>
        <div>
          <div>
            <IconContainer><UIcon /></IconContainer>
            <span>{data.FirstName} {data?.LastName}</span>
          </div>
        </div>
        <MainContainer>
          <div>
            <span>Status</span>
            {/* <span style={data.Status=='Disabled'?{color:'red',backgroundColor:"lightpink"}:{}}>{data.Status}</span> */}
          </div>
          <div>
            <span>First Name</span><span>{data?.FirstName}</span>
          </div>
          <div>
            <span>Surname</span><span>{data?.LastName}</span>
          </div>
          <div>
            <span>Email</span><span>{data?.Email}</span>
          </div>
          <div>
            <span>Phone Number</span><span>{data?.PhoneNumber}</span>
          </div>
          <div>
            <span>Role</span><span>{data?.RoleList?.Roles.join(', ')}</span>
          </div>
        </MainContainer>
      </div>
    </ModalContainer>
  )
}

export default ViewDetails

const MainContainer = styled.div`
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:20px;
  padding:30px;
  /* & > div:first-of-type > span:last-of-type{
    padding: 6px 10px;
    color:#11643C;
    background-color:#E0FAEE;
    border-radius: 3px;
  } */
  & > div{
    flex:1;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }

  & > div:last-child {
    gap: 350px;
    align-items: start;
    line-height: 2;

    & span {
      text-align: right;
      line-height: 2;
    }
  }
  
  & > div > span:first-of-type{
    color:#4E5A62;
  }
  
`